module.exports = __webpack_public_path__ + "img/icon_a.940c6aa4.svg";